<ng-container *ngIf="!!candidate?.experience; else infoFromCandidate">
  <p *ngIf="flexLayout; else block">
    <span class="candidate-job-title text-truncate">
      {{ candidate.currentJobTitle }}
    </span>|
    <span class="candidate-job-period">
      {{ candidate.experience?.period }}
    </span>
    <ng-container *ngIf="!!candidate.experienceYears">
      |<span class="candidate-job-period">{{candidate.experienceYears}} years of
        experience</span>
    </ng-container>
  </p>
  <ng-template #block>
    <span class="d-block text-truncate">
      {{ candidate.experience?.title }}
    </span>
    <span class="d-block">
      {{ candidate.experience?.period }}
    </span>
  </ng-template>
</ng-container>

<ng-template #infoFromCandidate>
  <p *ngIf="!!candidate">
    <span
      *ngIf="candidate?.currentJobTitle"
      class="candidate-job-title text-truncate"
    >
      {{ candidate.currentJobTitle }}
    </span>

    <ng-container
      *ngIf="candidate?.latestExperienceStartDate && candidate?.latestExperienceEndDate"
    >
      |
      <span class="candidate-job-period">
        {{calculateDate(candidate.latestExperienceStartDate)}} -
        {{calculateDate(candidate.latestExperienceEndDate)}}
      </span>
    </ng-container>

    <ng-container *ngIf="!!candidate.experienceInYears">
      |<span class="candidate-job-period">{{candidate.experienceInYears}} years
        of
        experience</span>
    </ng-container>

  </p>
</ng-template>
